import { useEnvContext } from "context/EnvContext";
import { APP_CAREPROVIDER, APP_CLINIC } from "core/consts";
import {
  activateSalesforceChat,
  isAppEmbedded,
} from "core/model/utils/featureFlags";
import { useShouldDeactivateCustomerSupportChat } from "core/model/utils/useShouldDeactivateCustomerSupportChat";
import SalesforceFrame from "./index";

function SalesforceFrameGate() {
  const { app } = useEnvContext();
  const isSalesforceEnabled = activateSalesforceChat();
  const shouldDeactivate = useShouldDeactivateCustomerSupportChat();

  const isSenderOrReceiverApp =
    app === APP_CLINIC || app === APP_CAREPROVIDER;

  if (
    !isSenderOrReceiverApp ||
    isAppEmbedded() ||
    !isSalesforceEnabled ||
    shouldDeactivate
  ) {
    return null;
  }

  return <SalesforceFrame />;
}

export default SalesforceFrameGate;
